<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#F66">
        <g>
          <g>
            <g>
              <path
                d="M3.5 0c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L3.5 1h-2c-.245 0-.45.177-.492.41L1 1.5V12h14V1.5c0-.245-.177-.45-.41-.492L14.5 1h-2c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L12.5 0h2c.78 0 1.42.595 1.493 1.356L16 1.5v13c0 .78-.595 1.42-1.356 1.493L14.5 16h-13c-.78 0-1.42-.595-1.493-1.356L0 14.5v-13C0 .72.595.08 1.356.007L1.5 0h2zM15 13H1v1.5c0 .245.177.45.41.492L1.5 15h13c.245 0 .45-.177.492-.41L15 14.5V13zM9.5 0c.276 0 .5.224.5.5V5h1.5c.4 0 .628.44.426.762l-.05.067-3.5 4c-.199.228-.553.228-.752 0l-3.5-4C3.84 5.506 4.07 5 4.5 5H6V.5c0-.245.177-.45.41-.492L6.5 0zM9 1H7v4.5c0 .245-.177.45-.41.492L6.5 6h-.898L8 8.74 10.397 6H9.5c-.245 0-.45-.177-.492-.41L9 5.5V1z"
                transform="translate(-1262 -148) translate(1250 60) translate(0 80) translate(12 8)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'ArchiveIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
